import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { EmployeeModel } from '../model/index';

@Injectable()
export class EmployeeService {
    private headers = new Headers({
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'

        //'Content-Type': 'application/x-www-form-urlencoded charset=UTF-8', 'Accept': 'q=0.8;application/json;q=0.9'
    });
    private employeeUrl = 'api/employee';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getEmployeeList(query: any): Promise<EmployeeModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.employeeUrl}/employeeList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getEmployee(empid: number): Promise<EmployeeModel> {
        const url = `${this.employeeUrl}/employeeList?empid=${empid}`;
        return this.http.get(url)
            .toPromise()
            .then(response => response.json().data as EmployeeModel)
            .catch(this.handleError);
    }

    getUserList(query: any): Promise<EmployeeModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.employeeUrl}/userList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    addUpdateEmployee(data: any): Promise<any> {
        let body = new URLSearchParams();
        for (let key in data) {
            body.set(key, data[key]);
        }

        let options = new RequestOptions({
            headers: this.headers
        });

        const url = `${this.employeeUrl}/addUpdateEmployee`;
        return this.http.post(url, body.toString(), options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}




// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/employee.service.ts